import { useQuery } from "@tanstack/react-query";

import { useIsFeatureEnabled } from "#app/featureToggle";
import { enabledOptimizationsQuery } from "#modules/optimizations/infra/enabledOptimizations.query";
import { Features } from "#types/FeatureToggleTypes";
import {
  computeOptimizedMaterialCosts,
  NO_OPTIMIZED_MATERIAL_COSTS,
  OptimizedMaterialCosts,
} from "shared";

export const useOptimizedMaterialCosts = (
  quoteRequestId: string | null | undefined,
): OptimizedMaterialCosts => {
  const enabledOptimizations = useIsFeatureEnabled(Features.COSTING_OPTIMIZATION);

  const { data } = useQuery({
    ...enabledOptimizationsQuery({ quoteRequestId: quoteRequestId ?? "" }),
    enabled: !!quoteRequestId && enabledOptimizations,
  });

  return data ? computeOptimizedMaterialCosts(data) : NO_OPTIMIZED_MATERIAL_COSTS;
};
